export const ZONA_HORARIA_SISTEMA = 'America/Guayaquil'

function partesFecha(fecha) {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: ZONA_HORARIA_SISTEMA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(fecha)

  return Object.fromEntries(partes.map(({ type, value }) => [type, value]))
}

/** Devuelve YYYY-MM-DD usando siempre la fecha civil de Ecuador/Perú (UTC-5). */
export function fechaIsoSistema(fecha = new Date()) {
  const { year, month, day } = partesFecha(fecha)
  return `${year}-${month}-${day}`
}

/** Suma días a una fecha civil YYYY-MM-DD sin convertirla a la zona del navegador. */
export function sumarDiasFechaIso(valor, dias) {
  const coincidencia = String(valor || '').match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (!coincidencia) return ''
  const fecha = new Date(Date.UTC(
    Number(coincidencia[1]),
    Number(coincidencia[2]) - 1,
    Number(coincidencia[3]) + Number(dias || 0),
  ))
  return fecha.toISOString().slice(0, 10)
}

/**
 * Los DATETIME de MySQL llegan sin zona. Se interpretan como hora del sistema
 * (UTC-5), no como hora local del computador del usuario.
 */
export function fechaServidorAInstantanea(valor) {
  if (!valor) return null
  const texto = String(valor).trim()
  const tieneZona = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(texto)
  const normalizada = /^\d{4}-\d{2}-\d{2}$/.test(texto)
    ? `${texto}T00:00:00`
    : (texto.includes('T') ? texto : texto.replace(' ', 'T'))
  const fecha = new Date(tieneZona ? normalizada : `${normalizada}-05:00`)
  return Number.isNaN(fecha.getTime()) ? null : fecha
}

export function formatearFechaHoraSistema(valor, opciones = {}) {
  const fecha = valor instanceof Date ? valor : fechaServidorAInstantanea(valor)
  if (!fecha || Number.isNaN(fecha.getTime())) return valor ? String(valor) : '-'

  const usaEstilo = 'dateStyle' in opciones || 'timeStyle' in opciones
  const formato = usaEstilo
    ? { timeZone: ZONA_HORARIA_SISTEMA, ...opciones }
    : {
        timeZone: ZONA_HORARIA_SISTEMA,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        ...opciones,
      }

  return fecha.toLocaleString('es-EC', formato)
}

export function formatearFechaSistema(valor, opciones = {}) {
  const fecha = valor instanceof Date ? valor : fechaServidorAInstantanea(valor)
  if (!fecha || Number.isNaN(fecha.getTime())) return valor ? String(valor) : '-'

  const formato = 'dateStyle' in opciones
    ? { timeZone: ZONA_HORARIA_SISTEMA, ...opciones }
    : {
        timeZone: ZONA_HORARIA_SISTEMA,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        ...opciones,
      }

  return fecha.toLocaleDateString('es-EC', formato)
}

export function formatearHoraSistema(valor, opciones = {}) {
  const fecha = valor instanceof Date ? valor : fechaServidorAInstantanea(valor)
  if (!fecha || Number.isNaN(fecha.getTime())) return valor ? String(valor) : '-'

  return fecha.toLocaleTimeString('es-EC', {
    timeZone: ZONA_HORARIA_SISTEMA,
    hour: '2-digit',
    minute: '2-digit',
    ...opciones,
  })
}

